<style scoped>

</style>
<template>
  <div>
    <div class="line text-center">
      <!-- <Select v-model="params.is_finish" @on-change="doSearch" placeholder="选择完成类型" style="width: 120px">
                <Option :value="0">未完成</Option>
                <Option :value="1">已完成</Option>
                <Option :value="2">所有类型</Option>
            </Select> -->
      <div class="search-input">
        <i-input
          v-model="params.search"
          placeholder="请输入搜索关键字"
          @on-enter="doSearch"
        />
      </div>
      <Ajaxbtn
        ref="searchBtn"
        :url="$util.api.query_expense_register"
        :params="params"
        type="search"
        @before="beforeSearch"
        @done="handleData"
        @fail="handleFail"
      />
    </div>

    <Table
      :columns="columns"
      :data="expense_registers"
      :loading="loading"
    />

    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>
  </div>
</template>
<script route="/invoice/register/expense_fk">
  import ExpenseInvoiceRegisterExpand from '../components/expense_invoice_register_expand'
  import {mapGetters} from "vuex";
  export default {
    /* router_info_start */
    router_info: '/invoice/register/expense_fk',
    /* router_info_end */

    components: { ExpenseInvoiceRegisterExpand },
    data() {
      return {
        loading: false,
        expense_registers: [],
        params: {
          search: '',
          per_page: 20,
          page: 1,
          is_finish: 0,
          payment_type: 1,
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 10
        },
        columns: [
          {
            title: '展开',
            type: 'expand',
            align: 'center',
            width: 40,
            render: (h, params) => {
              return h(ExpenseInvoiceRegisterExpand, {
                props: {
                  expense_invoice_registers: params.row.expense_invoice_registers
                }
              })
            }
          },
          {
            title: '申请人',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              const row = params.row;
              if (row.customer_id) {
                return h('CustomerPoptip', {
                  props: {
                    customer_id: row.customer_id
                  }
                }, [h('span', {
                  'class': {
                    'link': true
                  }
                }, row.customer.account)]);
              }
              return h('span', row.customer.account);
            }
          },
          {
            title: '序列号',
            align: 'center',
            minWidth: 100,
            key:'id'
          },
          {
            title: '团队',
            minWidth: 100,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('span', row.customer.team);
            }
          },
          {
            title: '关联类型',
            minWidth: 160,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('span', this.getLinkTitle(row))
            }
          },
          {
            title: '付款单 | 合同 | 备注',
            align: 'center',
            minWidth: 160,
            render: (h, params) => {
              const expense_group = params.row.expense_group
              const contract = params.row.contract
              const outsource_contract = params.row.outsource_contract
              const register_type = params.row.register_type
              if (register_type === 1) {
                return h('span', expense_group ? expense_group.uid : '-')
              } else if (register_type === 2) {
                return h('span', contract ? contract.uid : '-')
              } else if (register_type === 3) {
                return h('span', outsource_contract ? outsource_contract.uid : '-')
              } else {
                return h('span', params.row.remark)
              }
            }
          },
          {
            title: '供应商',
            align: 'center',
            minWidth: 160,
            render: (h, params) => {
              const expense_group = params.row.expense_group
              return h('span', expense_group ? expense_group.payee_company : '-')
            }
          },
          {
            title: '是否货款',
            align: 'center',
            minWidth: 50,
            render: (h, params) => {
              const is_goods_payment = params.row.expense_group ? params.row.expense_group.has_stocks : 0
              return h('span', is_goods_payment ? '是' : '否')
            }
          },
          {
            title: '登记时间',
            align: 'center',
            minWidth: 160,
            render: (h, params) => {
              const row = params.row;
              return h('span', this.$util.formatTime(row.created_at));
            }
          },

        ]
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      ...mapGetters({
        companies_hash: 'async/companies_hash',
        teams_hash: 'async/root_teams_hash',
      }),
    },
    created() {
      //
    },
    mounted() {
      this.doSearch();
    },
    methods: {
      getLinkTitle(expense_register) {
        const register_type = expense_register.register_type
        if (register_type === 1) {
          return '付款单号'
        } else if (register_type === 2) {
          return '合同号'
        } else if (register_type === 3) {
          return '合同号'
        } else {
          return '备注'
        }
      },
      doSearch() {
        this.$refs.searchBtn.doAjax();
      },
      pageChange(new_page) {
        this.params.page = new_page;
        this.loading = true;
        this.$refs.searchBtn.doAjax(true);
      },
      beforeSearch() {
        this.params.page = 1;
        this.loading = true;
      },
      handleData(data) {
        this.loading = false;
        this.expense_registers = data.expense_registers;
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
      },
      handleFail(e) {
        this.loading = false;
        this.$Modal.error({title: '提示', content: e.message});
      },
    }
  }
</script>
